// Auth/protectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "Auth/authContext"
import PageSkeleton from "UI/Loading/pageSkeleton"

/*
    Usage in siteConfig:
        {
            path: "/dashboard",
            component: Dashboard,
            protected: true,
        }
*/
const ProtectedRoute = ({ children, redirectTo = "/login" }) => {
	const { isAuthenticated, isLoading } = useAuth()
	const location = useLocation()

	if (isLoading) return <PageSkeleton /> // Still verifying session — don't flash the login page

	if (!isAuthenticated) {
		// Pass current path so we can redirect back after login
		return <Navigate to={redirectTo} state={{ from: location.pathname }} replace />
	}

	return children
}

export default ProtectedRoute
